import { useMemo } from 'react';
import { StyledButton } from '@elements/Button';

interface IUserValueItem {
  qty?: number | string;
}

interface IContentTabProps {
  userValue: Record<string, IUserValueItem>;
  moveToNextStep?: () => void;
  lineItems?: any[];
}

export function ContentTab({
  userValue,
  moveToNextStep,
  lineItems,
}: IContentTabProps) {
  const completed = useMemo(
    () =>
      Object.values(userValue).some(item => Number(item.qty || 0)) ||
      (lineItems || []).length > 0,
    [userValue, lineItems],
  );

  return (
    <div className="sk:flex sk:items-center sk:justify-between sk:p-4">
      {completed ? (
        <>
          <h4 className="sk:m-0 sk:max-w-[350px]">
            Confirm contents once you have chosen a carton quantity for each
            item you&apos;d like to order
          </h4>
          <StyledButton
            type="button"
            onClick={() => moveToNextStep?.()}
            className="no-break sk:ml-6"
          >
            Confirm Contents
          </StyledButton>
        </>
      ) : (
        <h4 className="sk:m-0 sk:max-w-[350px]">
          Choose a Carton Quantity for the items you&apos;d like to order
        </h4>
      )}
    </div>
  );
}
